export class Campaign {
     
    private readonly id: number;
    private readonly name: string;
    private readonly audienceId: number;
    private readonly audioId: number;
    private readonly speed: number;
    private readonly status: string;
    private readonly type: "audio" | "hangup";
    private readonly createdAt: Date;
    private readonly modifiedAt: Date;
    private readonly startAt: Date;
    private readonly channelId: string;


    constructor( id: number, name: string, audienceId: number, audioId: number, speed: number, status: string, type: "audio" | "hangup", createdAt: Date, modifiedAt: Date, startAt: Date, channelId: string) {
        this.id = id;
        this.name = name;
        this.audienceId = audienceId;
        this.audioId = audioId;
        this.speed = speed;
        this.status = status;
        this.type = type;
        this.createdAt = createdAt;
        this.modifiedAt = modifiedAt;
        this.startAt = startAt;
        this.channelId = channelId;
    }

    
    public Id = (): number => {
        return this.id
    }
    public Name = (): string => {
        return this.name
    }
    public AudienceId = (): number => {
        return this.audienceId
    }

    public AudioId = (): number => {
        return this.audioId
    }

    public ChannelId = (): string => {
        return this.channelId;
    }
    
    public Speed = (): number => {
        return this.speed
    }
    public Status = (): string => {
        return this.status
    }

    public Type = (): "audio" | "hangup" => {
        return this.type
    }

    public CreatedAt = (): Date => {
        return this.createdAt
    }
    public StartAt = (): Date => {
        return this.startAt
    }
    public ModifiedAt = (): Date => {
        return this.modifiedAt
    }
}